import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=2eb39754&"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js&"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports